import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { reopenSolicitationThunk, resetDataReopenSolicitation } from "redux/Reducers/Concierge/reopenSolicitationSlicer";

import { useForm } from "antd/es/form/Form";

import "Assets/styles/default/components/Concierge/Modals/ReopenSolicitationModal.less"

import { Col, Form, Row, VertButton, VertInput, VertModal, VertTypography, notification } from "@vertem-core/vertice-ds";

const ReopenSolicitationModal = (props) => {
  const { isOpen, setIsOpen, solicitationId, onSuccess } = props;

  const [note, setNote] = useState();

  const [ form ] = useForm();

  const dispatch = useDispatch();

  const {
    dataReopenSolicitation,
    loadingReopenSolicitation,
    errorReopenSolicitation,
  } = useSelector(state =>
    state.ReopenSolicitation
  );

  const validations = {
    note: {
      rules: [{
        required: true,
        message: "Campo obrigatório."
      }]
    }
  };

  const handleNoteChange = (value) => {
    setNote(value);
  }

  const handleSubmit = () => {
    form.validateFields().then(() => {
      const reopen = {
        solicitationId,
        note,
      };

      dispatch(reopenSolicitationThunk(reopen));
    }).catch(() => {
      notification.error({
        message: "Preencha os campos corretamente.",
      });
    })
  }

  useEffect(() => {
    if (!dataReopenSolicitation) return;

    setIsOpen(false);

    notification.success({
      message: "Solicitação foi reaberta."
    });

    onSuccess();
  }, [dataReopenSolicitation]);

  useEffect(() => {
    if (!errorReopenSolicitation) return;

    notification.error({
      message: "Houve um erro ao reabrir solicitação, tente novamente."
    });

    dispatch(resetDataReopenSolicitation());
  }, [errorReopenSolicitation]);

  return (
    <VertModal
      className="concierge-reopen-modal"
      width={"50%"}
      open={isOpen}
      onCancel={() => setIsOpen(false)}
      destroyOnClose={true}
    >
      <Row>
        <Col>
          <VertTypography.Title>
            Você deseja reabrir esta solicitação?
          </VertTypography.Title>
        </Col>
      </Row>

      <Row>
        <Col>
          <VertTypography.Paragraph type="light">
            Ao confirmar esta ação, a solicitação será reaberta.
          </VertTypography.Paragraph>
        </Col>
      </Row>

      <Form form={form}>
        <Form.Item
          name="note"
          rules={validations.note.rules}
        >
          <VertInput.TextArea
            className="note"
            placeholder="Escreva o motivo da reabertura"
            value={note}
            onChange={(e) => handleNoteChange(e.target.value)}
          /> 
        </Form.Item>
      </Form>

      <Row className="actions" justify="end">
        <Col className="action-btn-group">
          <VertButton
            className="button-concierge"
            onClick={() => setIsOpen(false)}
          >
            Cancelar
          </VertButton>

          <VertButton
            className="btn-confirm"
            type="highlight"
            loading={loadingReopenSolicitation}
            onClick={handleSubmit}
          >
            Confirmar
          </VertButton>
        </Col>
      </Row>
    </VertModal>
  )
}

export default ReopenSolicitationModal;